// extracted by mini-css-extract-plugin
export default {"FormTextInput":"FormTextInput_FormTextInput__nvVzS"};